import { render, staticRenderFns } from "./AamsUnitBaseNature.vue?vue&type=template&id=624817ce&scoped=true&"
import script from "./AamsUnitBaseNature.vue?vue&type=script&lang=js&"
export * from "./AamsUnitBaseNature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624817ce",
  null
  
)

export default component.exports